import { Button, Grid } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import {
  useDetalheOcorrencia,
  useEnviarExclusao
} from "../../api/ESocialJTServiceApi";
import ArquivarButton from "../../components/arquivar/ArquivarButton";
import DataPanel from "../../components/data/DataPanel";
import LabelEstado from "../../components/estado/LabelEstado";
import DetalhesEvento from "../../components/operacional/DetalhesEvento";
import { Alert } from "@mui/material";
import Page from "../../components/layout/page/Page";
import ErrosProcessamento from "../../components/ocorrencia/ErrosProcessamento";
import PageHeader from "../../components/page-header/PageHeader";
import Voltar from "../../components/voltar/Voltar";
import { getDataGeracao, getTitulo } from "../../shared/ocorrenciaUtil";
import { useDialog } from "muibox";
import { useLoading } from "../../components/loading/LoadingProvider";
import useFeedback from "../../components/feedback/useFeedback";
import { PROCESSADO_COM_SUCESSO } from "../../shared/estados";

function EventoDetalhePage() {
  const { id } = useParams();
  const dialog = useDialog();
  const setLoading = useLoading();
  const enviarExclusao = useEnviarExclusao();
  const { showSuccess, showError } = useFeedback();
  const navigate = useNavigate();

  const { data: ocorrencia = {}, isLoading, error } = useDetalheOcorrencia(id);

  const codTipo = ocorrencia.evento?.tipoEvento?.codTipo;
  const permiteExcluir =
    ((codTipo >= 1200 && codTipo <= 1299) ||
      (codTipo >= 2200 && codTipo <= 2499)) &&
    ocorrencia?.evento?.estado?.id === PROCESSADO_COM_SUCESSO;

  async function handleExcluir() {
    try {
      await dialog.confirm({
        title: `Deseja enviar o evento de exclusão (S-3000) para este evento?`,
        ok: { text: "CONFIRMAR", color: "primary" },
        cancel: { text: "CANCELAR", color: "primary" }
      });
    } catch {
      return;
    }
    setLoading(true);

    enviarExclusao.mutate(id, {
      onSuccess: () => {
        showSuccess(
          "Evento de exclusão enviado com sucesso. Verifique o retorno do eSocial."
        );
        navigate("/");
      },
      onError: showError,
      onSettled: () => setLoading(false)
    });
  }

  return (
    <Page maxWidth="lg">
      {error && (
        <Alert severity="error">
          {error.message || "Não foi possível consultar a ocorrência."}
        </Alert>
      )}
      <DataPanel loading={isLoading}>
        <PageHeader
          primary={getTitulo(ocorrencia)}
          secondary={getDataGeracao(ocorrencia.dataRecebimento)}
          commands={[
            <ArquivarButton ocorrencia={ocorrencia} />,
            <LabelEstado estado={ocorrencia?.evento?.estado} />,
            <Voltar />
          ]}
        />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ErrosProcessamento ocorrencia={ocorrencia} />
          </Grid>
          <Grid item xs={12}>
            {ocorrencia.id && <DetalhesEvento ocorrencia={ocorrencia} />}
          </Grid>
          {permiteExcluir && (
            <Grid item xs={12}>
              <Button
                size="large"
                fullWidth
                variant="contained"
                color="error"
                onClick={handleExcluir}
              >
                Enviar Evento de Exclusão
              </Button>
            </Grid>
          )}
        </Grid>
      </DataPanel>
    </Page>
  );
}

export default EventoDetalhePage;
